// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BETypeElement } from './BETypeElement';
import { EnumAccessModifier } from '../../../../../com/MetaPattern/MDA/MD/Base/EnumAccessModifier';
import { EnumDTPType } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumDTPType';
import { BEComponent } from './BEComponent';
import { BEServiceAction } from './BEServiceAction';
import { BLParameter } from './BLParameter';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { BEBusinessLogicExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/BEBusinessLogicExtend';
/**
 * 商业逻辑 实体类
 * 商业逻辑
 */
export class BEBusinessLogic extends BETypeElement {
  /** 返回数据类型 : 返回数据类型，无返回使用void */
  private _returnDataType: EnumDataType;

  /** 设置：返回数据类型 */
  public get returnDataType() {
    return this._returnDataType;
  }

  /** 获取：返回数据类型 */
  public set returnDataType(value: EnumDataType) {
    this._returnDataType = value;
  }

  /** 引用类型 : 返回值引用类型，当数据类型为引用类型时有效 */
  private _returnReferenceType: string;

  /** 设置：引用类型 */
  public get returnReferenceType() {
    return this._returnReferenceType;
  }

  /** 获取：引用类型 */
  public set returnReferenceType(value: string) {
    this._returnReferenceType = value;
  }

  /** 返回值描述 : 返回值描述 */
  private _returnDescription: string;

  /** 设置：返回值描述 */
  public get returnDescription() {
    return this._returnDescription;
  }

  /** 获取：返回值描述 */
  public set returnDescription(value: string) {
    this._returnDescription = value;
  }

  /** 访问修饰符 : 访问修饰符 */
  private _accessModifier: EnumAccessModifier;

  /** 设置：访问修饰符 */
  public get accessModifier() {
    return this._accessModifier;
  }

  /** 获取：访问修饰符 */
  public set accessModifier(value: EnumAccessModifier) {
    this._accessModifier = value;
  }

  /** 是否是集合 : 返回值是否是集合 */
  private _returnIsCollection: boolean;

  /** 设置：是否是集合 */
  public get returnIsCollection() {
    return this._returnIsCollection;
  }

  /** 获取：是否是集合 */
  public set returnIsCollection(value: boolean) {
    this._returnIsCollection = value;
  }

  /** 是否分页 : 返回值是否是否分页 */
  private _returnIsPaged: boolean;

  /** 设置：是否分页 */
  public get returnIsPaged() {
    return this._returnIsPaged;
  }

  /** 获取：是否分页 */
  public set returnIsPaged(value: boolean) {
    this._returnIsPaged = value;
  }

  /** 支持分布式事务 : 是否支持分布式事务 */
  private _enableDistributeTransaction: boolean;

  /** 设置：支持分布式事务 */
  public get enableDistributeTransaction() {
    return this._enableDistributeTransaction;
  }

  /** 获取：支持分布式事务 */
  public set enableDistributeTransaction(value: boolean) {
    this._enableDistributeTransaction = value;
  }

  /** 分布式事务协议 : 分布式事务协议 */
  private _dTPType: EnumDTPType;

  /** 设置：分布式事务协议 */
  public get dTPType() {
    return this._dTPType;
  }

  /** 获取：分布式事务协议 */
  public set dTPType(value: EnumDTPType) {
    this._dTPType = value;
  }

  /** 开启本地事务 : 是否开启本地事务 */
  private _enableLocalTransaction: boolean;

  /** 设置：开启本地事务 */
  public get enableLocalTransaction() {
    return this._enableLocalTransaction;
  }

  /** 获取：开启本地事务 */
  public set enableLocalTransaction(value: boolean) {
    this._enableLocalTransaction = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 服务操作 */
  private _serviceActions: Array<BEServiceAction>;

  /** 获取：服务操作 */
  public get serviceActions() {
    return this._serviceActions;
  }

  /** 设置：服务操作 */
  public set serviceActions(value: Array<BEServiceAction>) {
    this._serviceActions = value;
  }

  /** 参数 */
  private _parameters: Array<BLParameter>;

  /** 获取：参数 */
  public get parameters() {
    return this._parameters;
  }

  /** 设置：参数 */
  public set parameters(value: Array<BLParameter>) {
    this._parameters = value;
  }

  constructor() {
    super();
    BEBusinessLogicExtend.Init(this);
    this._returnDataType = EnumDataType.String;
    this._returnReferenceType = '';
    this._returnDescription = '';
    this._accessModifier = EnumAccessModifier.Public;
    this._returnIsCollection = false;
    this._returnIsPaged = false;
    this._enableDistributeTransaction = false;
    this._dTPType = EnumDTPType.TCC;
    this._enableLocalTransaction = false;
    this._component_ID = '';
    this._component = null;
    this._serviceActions = new Array<BEServiceAction>();
    this._parameters = new Array<BLParameter>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEBusinessLogic, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.returnDataType = element.returnDataType;
      this.returnReferenceType = element.returnReferenceType;
      this.returnDescription = element.returnDescription;
      this.accessModifier = element.accessModifier;
      this.returnIsCollection = element.returnIsCollection;
      this.returnIsPaged = element.returnIsPaged;
      this.enableDistributeTransaction = element.enableDistributeTransaction;
      this.dTPType = element.dTPType;
      this.enableLocalTransaction = element.enableLocalTransaction;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.returnDataType = json.ReturnDataType as EnumDataType;
    this.returnReferenceType = json.ReturnReferenceType;
    this.returnDescription = json.ReturnDescription;
    this.accessModifier = json.AccessModifier as EnumAccessModifier;
    this.returnIsCollection = json.ReturnIsCollection;
    this.returnIsPaged = json.ReturnIsPaged;
    this.enableDistributeTransaction = json.EnableDistributeTransaction;
    this.dTPType = json.DTPType as EnumDTPType;
    this.enableLocalTransaction = json.EnableLocalTransaction;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    if (json.ServiceActions && json.ServiceActions.length > 0) {
      json.ServiceActions.forEach((element: any) => {
        const bEServiceAction = BEServiceAction.Create(element);
        // bEServiceAction.businessLogic = this;
        this.serviceActions.push(bEServiceAction);
      });
    }
    if (json.Parameters && json.Parameters.length > 0) {
      json.Parameters.forEach((element: any) => {
        const bLParameter = BLParameter.Create(element);
        // bLParameter.businessLogic = this;
        this.parameters.push(bLParameter);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ReturnDataType = this.returnDataType;
    json.ReturnReferenceType = this.returnReferenceType;
    json.ReturnDescription = this.returnDescription;
    json.AccessModifier = this.accessModifier;
    json.ReturnIsCollection = this.returnIsCollection;
    json.ReturnIsPaged = this.returnIsPaged;
    json.EnableDistributeTransaction = this.enableDistributeTransaction;
    json.DTPType = this.dTPType;
    json.EnableLocalTransaction = this.enableLocalTransaction;
    json.Component_ID = this.component_ID;
    if (this.serviceActions && this.serviceActions.length > 0) {
      json.ServiceActions = [];
      this.serviceActions.forEach((element) => {
        json.ServiceActions.push(element.toJson());
      });
    }
    if (this.parameters && this.parameters.length > 0) {
      json.Parameters = [];
      this.parameters.forEach((element) => {
        json.Parameters.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('返回值', 'returnDataType', '返回数据类型', EnumDataType.Reference, this.returnDataType, true, '返回数据类型，无返回使用void', 'EnumDataType', 'PGRowEnumValue');
    context.addRow('返回值', 'returnReferenceType', '引用类型', EnumDataType.String, this.returnReferenceType, true, '返回值引用类型，当数据类型为引用类型时有效', '', 'PGRowDataTypeValue:all');
    context.addRow('返回值', 'returnDescription', '返回值描述', EnumDataType.String, this.returnDescription, true, '返回值描述', '', '');
    context.addRow('代码属性', 'accessModifier', '访问修饰符', EnumDataType.Reference, this.accessModifier, true, '访问修饰符', 'EnumAccessModifier', 'PGRowEnumValue');
    context.addRow('返回值', 'returnIsCollection', '是否是集合', EnumDataType.Bool, this.returnIsCollection, true, '返回值是否是集合', '', '');
    context.addRow('返回值', 'returnIsPaged', '是否分页', EnumDataType.Bool, this.returnIsPaged, true, '返回值是否是否分页', '', '');
    context.addRow('事务', 'enableDistributeTransaction', '支持分布式事务', EnumDataType.Bool, this.enableDistributeTransaction, true, '是否支持分布式事务', '', '');
    context.addRow('事务', 'dTPType', '分布式事务协议', EnumDataType.Reference, this.dTPType, true, '分布式事务协议', 'EnumDTPType', 'PGRowEnumValue');
    context.addRow('事务', 'enableLocalTransaction', '开启本地事务', EnumDataType.Bool, this.enableLocalTransaction, true, '是否开启本地事务', '', '');
    return context;
  }

  static Create(json: any): BEBusinessLogic {
    const bEBusinessLogic = new BEBusinessLogic();
    bEBusinessLogic.Deserialize(json);
    bEBusinessLogic.json = json;
    return bEBusinessLogic;
  }
}
